<div class="flex flex-row items-center gap-2">
    <input
        class="flex-grow disabled:!bg-white"
        disabled
        type="text"
        value="{{
            libraryFile?.name || ('translate_no_file_selected' | translate)
        }}"
    />

    <button
        (click)="showCreateLibraryFileDialog()"
        class="action-icon action-icon-add"
        [disabled]="isDisabled"
        [appTooltip]="'translate_add_new' | translate"
    >
        <i class="fa-light fa-plus"></i>
    </button>
    <button
        (click)="showLibraryDialog()"
        [disabled]="isDisabled"
        class="action-icon action-icon-warning relative"
        [appTooltip]="'translate_select_from_library' | translate"
    >
        <i class="fa-light fa-paperclip"></i>
        @if (libraryFile) {
            <p
                class="absolute -end-1.5 -top-1.5 flex h-4 w-4 items-center justify-center whitespace-nowrap rounded-full bg-emerald-500 text-xs font-bold text-white shadow"
            >
                1
            </p>
        }
    </button>
    @if (libraryFile) {
        <button
            (click)="removeFile()"
            [disabled]="isDisabled"
            class="action-icon action-icon-delete"
            [appTooltip]="'translate_remove' | translate"
        >
            <i class="fa-light fa-times"></i>
        </button>
    }
</div>

<!-- Template for select button -->
<ng-template let-item="item" #selectButtonTemplate>
    <button
        (click)="dismissLibraryFileListModal(); updateFile(item)"
        [disabled]="isDisabled"
        class="action-icon action-icon-primary"
        [appTooltip]="'translate_select' | translate"
    >
        <i class="fa-light fa-check"></i>
    </button>
</ng-template>
